import { Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { MaterialModule } from 'jk-service';
import {
  JkBaseComponent,
} from 'jk-service';
import { idNameItem, jkLib, jkRestReturn, OpenWinLoadOption } from 'jk-service';
import { StkmbService } from '../services/stkmb.service';
import { StklgService, StklmService, StkmaallService, StkmwService } from '../_service_stk';
import { StktqService } from '../services/stktq.service';
import { StockService } from '../services/stock.service';
//import { buysaleList, Stklg, Stktq } from '../_stk';
import { sendButtonStyle } from '../services/stock.service';

import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule, JkgridwinComponent } from 'jk-advcom';
import { buysaleList } from '../capitalClass';
import { Stklg, Stktq } from '../_entity_stk';


@Component({
  selector: 'app-sea-future-order',
  standalone: true,
  imports: [MaterialModule, JackBaseComponentModule, AdvComModule],
  templateUrl: './sea-future-order.component.html',
  //styleUrl: './sea-future-order.component.css',
  styles: [sendButtonStyle]
})
export class SeaFutureOrderComponent extends JkBaseComponent implements OnInit {
  stkmaallSrv = inject(StkmaallService);
  stkmbSrv = inject(StkmbService);
  stkmwSrv = inject(StkmwService);
  stklmSrv = inject(StklmService);
  stktqSrv = inject(StktqService);
  stockSrv = inject(StockService);
  stklgSrv = inject(StklgService);

  /*@ViewChild('zoomDiv') zoomDiv!: ElementRef;
  isZoomed: boolean = false;
  doZoomChange() {
    this.isZoomed = !this.isZoomed;
    if (this.isZoomed) {
      this.zoomDiv.nativeElement.style.width = this.pWidth.toString()+"px";
    } else {
      this.zoomDiv.nativeElement.style.width = '350px';
    }
  }
  @Input() pWidth: number = 350;
  */
  // 海期訂單 委託 STKTQ
  stktqGrid!: JkgridwinComponent;
  replyGrid!: JkgridwinComponent;
  date: string = jkLib.nowDate();
  buysaleList: idNameItem[] = buysaleList;

  override ngOnInit() {
    super.ngOnInit();
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      if (this.stkmbSrv.seaAccountList.length > 0)
        this.stktqSrv.newItem.TQ002 = this.stkmbSrv.seaAccountList[0].id;
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    }, 1000);
  }
  afterGridReady($event: JkgridwinComponent) {
    this.stktqGrid = $event;
    //this.doQuery();
  }
  get exchangeId(): string {
    return this.stktqSrv.newItem.TQ004;
  }
  set exchangeId(value: string) {
    this.stkmaallSrv.exchangeId = value;
    this.stktqSrv.newItem.TQ004 = value;
  }
  doQuery() {
    if (!this.stktqSrv.newItem.TQ002) return;
    let where = ` AND TQ001='${this.date}' AND TQ002='${this.stktqSrv.newItem.TQ002}'`;
    this.stktqGrid.doQuery2('STKTQ', 'S01', 'S', where);
  }
  stklg: Stklg = new Stklg(); //
  //@Input() _stockno: string = '';
  get stockno(): string {
    return this.stktqSrv.newItem.TQ005;
  }
  set stockno(value: string) {
    //this.getStklg(value);
    let r: any = this.stkmaallSrv.idNameList.find((item) => item.id === value);
    if (r) {
      if (r.ps2 !== this.stktqSrv.newItem.TQ004) {
        this.page.showAlert('交易所不同');
        return;
      }
      this.stktqSrv.newItem.TQ005 = r.id;
      this.stktqSrv.newItem.TQ029 = r.name;//  商品名稱
      this.stktqSrv.newItem.TQ030 = 'O';//商品分類
      this.stktqSrv.newItem.TQ006 = r.MA030;
    } else {
      this.stktqSrv.newItem.TQ005 = '';
      this.stktqSrv.newItem.TQ029 = '';
      this.stktqSrv.newItem.TQ006 = '';
    }
    this.stktqSrv.newItem.TQ005 = value;
  }
  async doSend() {
    let bool = await this.stktqSrv.doBeforeSend(this.stkmbSrv.uId);
    if (bool) {
      let body = {
        prid: 'SendOverseaFutureOrder',
        item: this.stktqSrv.newItem,
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        this.page.showToast('委託成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();
      } else {
        await this.page.showAlert('委託失敗:' + ret.getResultError());
      }
    }
  }
  onTQ001ValueChange($event: string) {
    this.doQuery();
  }
  // 交易所變更
  onExchangeValueChange($event: string) {
    this.stkmaallSrv.setExchangeStockList($event);
  }
  onValueChange($event: string) {
    //throw new Error('Method not implemented.');
  }
  onBuySaleValueChange($event: string) {
    //throw new Error('Method not implemented.');
  }
  getStklg(stockno: string) {
    this.stockSrv.kmSaiPost({ prid: 'GetSeaFutureQuote', item: { LG004: stockno } }).then((ret) => {
      if (ret.result) {
        this.stklg = ret.obj;
        this.stktqSrv.newItem.TQ008 = this.stklg.LG010;
      } else {
        this.page.showToast('查詢失敗:' + ret.getResultError());
      }
    });
  }
  onDateValueChange($event: string) {
    this.doQuery();
    this.doQueryReply();
  }

  stocknoValueChange($event: string) {
    this.getStklg($event);
  }
  async doChangePrice() {
    let item: Stktq = this.stktqGrid.gridSrv.getFocusedRowData();
    if (item) {
      let newPrice = await this.page.showInput('價格:', '請輸入新價格', item.TQ008.toString(), 'text');
      if (!newPrice) return;
      // Long CorrectPriceBySeqNo([in] BSTR bstrLogInID, [in] VARIANT_BOOL bAsyncOrder, [in] BSTR bstrAccount,
      //[in] BSTR bstrSeqNo, [in] BSTR bstrPrice, [in] LONG nTradeType,[out] BSTR* bstrMessage);
      let body = {
        prid: 'CorrectPriceBySeqNo',//證期權改價
        table: 'STKTQ',
        key1: item.TQ001,
        key2: item.TQ002,
        key3: item.TQ003,
        price: newPrice,
        tradeType: item.TQ015, // 證券0:ROD   期選0:ROD  1:IOC  2:FOK
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('改價成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();

      } else {
        await this.page.showAlert('改價失敗:' + ret.getResultError());
      }
    } else {
      await this.page.showAlert('請先選擇委託單');
    }

  }
  async doChangeQty() {
    let item: Stktq = this.stktqGrid.gridSrv.getFocusedRowData();
    if (item) {
      let decreaseQty = await this.page.showInput('口數:', '請輸入取消口數', item.TQ017.toString(), 'text');
      if (!decreaseQty) {
        return;
      }

      let body = {
        prid: 'DecreaseOrderBySeqNo',//
        key1: item.TQ001,
        key2: item.TQ002,
        key3: item.TQ003,
        table: 'STKTQ',
        decreaseQty: jkLib.fixNumber(decreaseQty),
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('修改口數成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();

      } else {
        await this.page.showAlert('修改口數失敗:' + ret.getResultError());
      }
    } else {
      await this.page.showAlert('請先選擇委託單');
    }

  }
  async doDelete() {
    let item = this.stktqGrid.gridSrv.getFocusedRowData();
    if (item) {
      let body = {
        prid: 'CancelOrderBySeqNo',//
        key1: item.TQ001,
        key2: item.TQ002,
        key3: item.TQ003,
        table: 'STKTQ',
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('刪單成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();

      } else {
        await this.page.showAlert('刪單失敗:' + ret.getResultError());
      }
    } else {
      await this.page.showAlert('請先選擇委託單');
    }

  }
  afterGridReadyReply($event: JkgridwinComponent) {
    this.replyGrid = $event;
  }
  doQueryReply() {

    if (!this.stktqSrv.newItem.TQ002) return;
    let where = ` AND MarketType='OF' AND Broker+CustNo='${this.stktqSrv.newItem.TQ002}' AND Date1='${this.date}'`;
    this.replyGrid.doQuery2('STKLM', 'S01', 'S', where);
  }
  async doComfirm() {// 回報過帳
    let item: any = this.replyGrid.itemFocused;
    if (!item) return;
    let ret = await this.stklmSrv.confirm(item, this.serverUrl);
    if (ret.result) {
      await this.page.showToast('回報成功');
    } else {
      await this.page.showAlert('回報失敗');
    }
  }
}
